import React from 'react';
import './Clock.css';

import { get12HourTime, get12HourPeriod } from '../../utils/datetime';

const propTypes = {
  date: React.PropTypes.object.isRequired
}

const Clock = props => (
  <div className='clock'>
    <span className='clock__time'>
      {get12HourTime(props.date)}
    </span>
    <span className='clock__period'>
      {get12HourPeriod(props.date)}
    </span>
  </div>
)

Clock.propTypes = propTypes;

export default Clock;



// WEBPACK FOOTER //
// ./src/components/Clock/Clock.js